export const UserRoles = {
  ADMIN: 1,
};